var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapsible-items-section',{staticClass:"faqs-section-module",attrs:{"title":_vm.attributes.faqSectionTitle,"intro":_vm.attributes.intro,"items":_vm.items,"open-text":_vm.$snippet('view_faqs', 'view faqs')}})}
var staticRenderFns = []

export { render, staticRenderFns }